module.exports = __webpack_public_path__ + "assets/img/fr-06d0991d.png";